module.exports = __webpack_public_path__ + "assets/playStore-e2d1ba.svg";